import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
/**
 * A label inside a menu, shown as core's menu heading.
 */
export default class LinkHeading extends Component {
  /** Renders its own `<li>`, so `listItems` does not wrap it in another. */
  static isListItem = true;
  view(vnode) {
    const link = this.attrs.link;
    const icon = link.icon();

    // The title stays a bare text node: core styles a `span` directly inside a
    // menu item as a clickable entry.
    return m("li", {
      className: "Dropdown-header LinksHeading",
      role: "presentation"
    }, !!icon && m(Icon, {
      name: icon
    }), " ", link.title());
  }
}
flarum.reg.add('fof-links', 'forum/components/LinkHeading', LinkHeading);